import React from 'react'
import Button from './UI/Button'
import Loader from './UI/Loader'
import T from './UI/T'
import Title from './UI/Title'

export default function Thanks({ saved, saveSession }) {
  if (saved === undefined)
    return <Loader />
  if (saved === false)
    return (
      <div className="flex flex-col justify-center items-center w-full h-screen lg:max-w-5xl mx-auto p-4 lg:p-6 pb-16 lg:pb-32 ">
        <Title>Error when submitting your entry</Title>
        <Button onClick={saveSession}>Retry</Button>
      </div>
    )
  return (
    <div className="flex flex-col justify-center items-center w-full h-screen lg:max-w-5xl mx-auto p-4 lg:p-6 pb-16 lg:pb-32 ">
      <div className="text-3xl lg:text-5xl font-bold mb-10 lg:mb-16 max-w-lg text-center uppercase leading-tight"><T>sent.title</T></div>
      {/* <p className="text-center"><T>sent.subtitle</T></p> */}
      {/* <Button onClick={() => window.location.reload()}>New photo</Button> */}
    </div>
  )
}
